import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { forceFinderRefresh } from 'redux/actions'

const useFinderRefresh = () => {
  const dispatch = useDispatch()
  const { currentFolder } = useCurrentFolderStore()

  return useCallback(() => {
    if (!!currentFolder) dispatch(forceFinderRefresh())
  }, [currentFolder, dispatch])
}

export { useFinderRefresh }
